(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valemont-order-notice"]) return;
  try {
    
(function(){
  function initializeNotice(){
    const dialog=document.getElementById('vm-order-notice');
    if(!dialog||dialog.dataset.initialized||typeof dialog.showModal!=='function')return;
    dialog.dataset.initialized='true';
    const key='valemont-instagram-order-notice-v1';
    const editor=Boolean(window.Shopify&&window.Shopify.designMode);
    try{if(!editor&&sessionStorage.getItem(key))return;}catch(e){}
    let previousOverflow='';
    dialog.querySelectorAll('[data-vm-notice-close]').forEach(function(button){button.addEventListener('click',function(){dialog.close();});});
    dialog.addEventListener('click',function(event){
      if(event.target!==dialog)return;
      const rect=dialog.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
    });
    dialog.addEventListener('close',function(){document.documentElement.style.overflow=previousOverflow;});
    window.setTimeout(function(){
      if(!dialog.isConnected)return;
      previousOverflow=document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow='hidden';
      try{if(!editor)sessionStorage.setItem(key,'1');}catch(e){}
    },500);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeNotice,{once:true});else initializeNotice();
  document.addEventListener('shopify:section:load',initializeNotice);
})();

  } catch(e) { console.error(e); }
})();
})();
